const Payment = require('@/lib/Payments/Payment');
const { populate } = require('@/functions/objects');

class MellonWebECRPayment extends Payment {
    constructor(data = {}) {
        super(data);

        /**
         * @type {SignPaymentResponse}
         */
        this.signResponse = null;

        /**
         * @type {?EInvoicingSignPaymentResult}
         */
        this.signResult = null;

        /**
         * @type {MellonWebECRPaymentTaxBreakdown}
         */
        this.taxBreakdown = undefined;

        populate(this, data);
    }

    /**
     * @param {EInvoicingSignPaymentResult} signResult
     */
    setSignResult(signResult) {
        this.signResult = signResult;

        // Store this info in the statusDetail so we can retrieve it again later.
        Object.keys(signResult).forEach((key) => {
            this.addToJsonStatusDetail(key, signResult[key]);
        });
    }

    getHydrationMap() {
        return {
            ...super.getHydrationMap(),
            signResponse: {},
            signResult: {},
            taxBreakdown: {},
        };
    }
}

module.exports = MellonWebECRPayment;
